// extracted by mini-css-extract-plugin
export default {"content":"OrderSummary_content__mJ-lE","list":"OrderSummary_list__3ZVWY","itemQty":"OrderSummary_itemQty__w4NUK","originalPriceText":"OrderSummary_originalPriceText__DDOxi"};